module.exports = __webpack_public_path__ + "static/media/circular-black-cross-icon.de1ddd74.svg";